import { render } from "./Expediciones.vue?vue&type=template&id=10084970&scoped=true"
import script from "./Expediciones.vue?vue&type=script&lang=ts"
export * from "./Expediciones.vue?vue&type=script&lang=ts"

import "./Expediciones.vue?vue&type=style&index=0&id=10084970&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10084970"

export default script